import React from 'react';

const AppRoute = ({ component: Component, routeKey, target, ...rest }) => {
  return (
    <Component target={target} {...rest} />
  );
};

export default AppRoute;
